<div class="col-12">
  <!--kind of upload choice-->
  <div class="grid">
    <div id="selectButtonsLine" class="col-12">
      <p-selectButton id="selectUploadChoice" #uploadChoice [options]="options" [ngClass]="btnClass"
                      [ngModel]="selectedOption"
                      (onChange)="updateContext($event)"></p-selectButton>
    </div>
  </div>

  <div id="depostiContent" class="treatmentChain">
    <!--Select treatment Chain and validation button-->
    <div class="grid">
      <div class="col-6">
        <div class="col-12" *ngIf="showChainSelection && selectedOption !== KindOfUpload.LRE">
          <div class="col-3"><h4>{{ 'UPLOAD_COMPONENT.TREATMENT_CHOICE_LABEL' | translate }}</h4></div>
          <div class="col-4">
            <p-dropdown [filter]="true" [options]="treatmentChains" placeholder="Select country" [(ngModel)]="selectedTreatmentChain"></p-dropdown>
          </div>
        </div>
        <div class="col-12" *ngIf="showChainSelection && selectedOption === KindOfUpload.LRE">
          <div class="col-3"><h4>{{ 'UPLOAD_COMPONENT.TREATMENT_CHOICE_LABEL' | translate }}</h4></div>
          <div class="col-4">
            <p-dropdown [filter]="true" [options]="treatmentChainsLre"
                        [(ngModel)]="selectedTreatmentChainLre"></p-dropdown>
          </div>
        </div>
      </div>
      <div class="col-6 align-right">
        <div class="tooltip">
          <button pButton type="button" [icon]="'fa fa-upload'" class="p-button-success"
                  [label]="'COMMON.VALIDATE' | translate"
                  [disabled]="!uploadIsPossible()"
                  (click)="sendFiles()">
          </button>
          <span class="tooltiptext" *ngIf="!bDefaultTreatmentChainExist && selectedTreatmentChain==treatmentChainService.defaultTreatmentChain">
            Aucune chaîne de traitement par défaut n'est paramétrée
          </span>
        </div>
      </div>
      <div class="col-12">
        <div class="col-6" *ngIf="selectedOption == KindOfUpload.LETTER">

          <div class="col-3"><h4>{{ 'UPLOAD_COMPONENT.PLANNED_LABEL' | translate }}</h4></div>
          <div class="col-9">
            <p-checkbox [binary]="true" [(ngModel)]="delayedSend" (onChange)="clearDelayedDate()"></p-checkbox>
          </div>
        </div>
      </div>
      <div *ngIf="delayedSend" class="col-12">
        <div class="col-6">
          <div class="col-3"><h4>{{ 'UPLOAD_COMPONENT.PLANNED_DATE_LABEL' | translate }}</h4></div>
          <div class="col-9">
            <p-calendar *ngIf="delayedSend" [(ngModel)]="delayedSendDate" [dateFormat]="'dd/mm/yy'"
                        [selectionMode]="'single'"
                        [readonlyInput]="true" [monthNavigator]="true"
                        [showButtonBar]="true"
                        [showIcon]="true" [minDate]="minDelayedSendDate"
                        [maxDate]="maxDelayedSendDate"></p-calendar>
          </div>
        </div>
      </div>
      <div *ngIf="selectedOption===KindOfUpload.SPOOL" class="col-12 treatmentChain">
        <div class="grid">
          <div class="col-12">
            <h4>{{ 'UPLOAD_COMPONENT.SPOOL_CHOICE' | translate }}</h4>
            <p-dropdown id="cut-parameters" [filter]="true"
                        (onChange)="selectSpool()"
                        [options]="spools"
                        [(ngModel)]="selectedSpool"
                        optionLabel="name"
                        [ngClass]="{'spool-invalid': !spoolFileValidity , 'spool-valid': spoolFileValidity}"></p-dropdown>
            <button *ngIf="enableCreateSpool" pButton type="button" [icon]="'fa fa-plus'"
                    class="p-button-warning new-spool-btn"
                    [label]="'COMMON.ADD' | translate"
                    (click)="showCreateSpoolDialog()"></button>
            <button *ngIf="spoolFileValidity && enableCreateSpool" pButton type="button" [icon]="'fa fa-trash-o'"
                    class="p-button-danger new-spool-btn"
                    [label]="'COMMON.DELETE' | translate"
                    (click)="deleteSpool()"></button>
          </div>
        </div>
      </div>
    </div>
    <p-dialog [styleClass]="'spool-modal'" [(visible)]="showCreateSpool"
              [header]="'UPLOAD_COMPONENT.CREATE_SPOOL_DIALOG' | translate" id="loader" [draggable]="false"
              [closable]="true" [resizable]="false"
              [modal]="true" [closeOnEscape]="false" [appendTo]="'body'" (onHide)="hideCreateSpoolDialog()">
      <app-create-spool [customerSpools]="spools" (modalDisplay)="hideCreateSpoolDialog()"></app-create-spool>
    </p-dialog>
    <!-- upload lre files -->
    <div *ngIf="selectedOption === KindOfUpload.LRE" class="grid">
      <div class="col-6">
        <div class="col-12">
          <app-files-upload
            filesTitle="{{'UPLOAD_COMPONENT.KIND_OF_FILE.PRINCIPAL_PLURAL' | translate}}"
            [moreThanOneFile]="true"
            [acceptedFiles]="gestListOfAcceptedFiles(FileStatus.ANNEXE)"
            [optional]="false"
            [shouldClearFiles]="shouldClearFiles"
            (isValid)="updateUploadValidity(FileStatus.PRINCIPAL,$event)"
            (selectedFiles)="updateFilesWithStatus(FileStatus.PRINCIPAL,$event)">
          </app-files-upload>
        </div>
        <div class="col-12" *ngIf="showLreDetectedProblems()">
          <p-fieldset [legend]="'UPLOAD_COMPONENT.DETECTED_PROBLEMS_LABEL' | translate">
            <ul>
              <li *ngIf="!principalFileValidity">
                {{ 'UPLOAD_COMPONENT.EXPLICATION_PRINCIPAL' | translate }}
              </li>
              <li *ngIf="selectedOption !== KindOfUpload.LRE && !annexeFileValidity">
                {{ 'UPLOAD_COMPONENT.EXPLICATION_ANNEX' | translate }}
              </li>
              <li *ngIf="selectedOption===KindOfUpload.MAILING && !dataFileValidity">
                {{ 'UPLOAD_COMPONENT.EXPLICATION_DATA' | translate }}
              </li>
              <li *ngFor="let error of getValidationErrors()">
                {{ error | translate }}
              </li>
            </ul>
          </p-fieldset>
        </div>
      </div>
      <div class="col-6 lre-parties">
        <p-tabView id="LREparties">
          <p-tabPanel [header]="('UPLOAD_COMPONENT.LRE_LRE_LABEL' | translate)">
            <ng-template pTemplate="content">
              <div class="grid">
                <div class="col-12">
                  <div class="col-4">
                    <span class="p-float-label">
                      <input id="lreSubject" [ngClass]="{'invalid': lreObject.subject === ''}"
                             [(ngModel)]="lreObject.subject" type="text" size="30" pInputText>
                      <label for="lreSubject">{{'UPLOAD_COMPONENT.LRE_SUBJECT_LABEL' | translate}}</label>
                    </span>
                  </div>
                  <div class="col-4">
                    <span class="p-float-label">
                      <input id="lreComments"
                             [(ngModel)]="lreObject.comments" type="text" size="30" pInputText>
                      <label for="lreComments">{{'UPLOAD_COMPONENT.LRE_COMMENTS_LABEL' | translate}}</label>
                    </span>
                  </div>
                </div>
              </div>
            </ng-template>
          </p-tabPanel>
          <p-tabPanel [header]="('UPLOAD_COMPONENT.LRE_RECIPIENT_LABEL' | translate)">
            <ng-template pTemplate="content">
              <div class="grid">
                <div class="col-12">
                  <div class="col-2">
                    {{'COMMON.SIGNER.TITLE' | translate}}
                  </div>
                  <div class="col-2">
                    <p-dropdown [options]="signerQualityItems" [(ngModel)]="lreObject.recipient.signerQuality"></p-dropdown>
                  </div>
                </div>
                <div class="col-12" *ngIf="lreObject.recipient.signerQuality === 'PERSONAL'">
                  <!-- recipient.title -->
                  <div class="col-4">
                    <p-dropdown [filter]="false" [options]="titleItems"
                                [(ngModel)]="lreObject.recipient.title"></p-dropdown>
                  </div>
                  <!-- recipient.firstName -->
                  <div class="col-4">
                  <span class="p-float-label">
                    <input id="recipientFirstName" [ngClass]="{'invalid': lreObject.recipient.firstName === ''}"
                           [(ngModel)]="lreObject.recipient.firstName" type="text" size="30" pInputText>
                    <label for="recipientFirstName">{{'UPLOAD_COMPONENT.LRE_S_FIRSTNAME_LABEL' | translate}}</label>
                  </span>
                  </div>
                  <!-- recipient.lastName -->
                  <div class="col-4">
                  <span class="p-float-label">
                    <input id="recipientLastName" [ngClass]="{'invalid': lreObject.recipient.lastName === ''}"
                           [(ngModel)]="lreObject.recipient.lastName" type="text" size="30" pInputText>
                    <label for="recipientLastName">{{'UPLOAD_COMPONENT.LRE_S_LASTNAME_LABEL' | translate}}</label>
                  </span>
                  </div>
                </div>
                <div class="col-12" *ngIf="lreObject.recipient.signerQuality === 'PROFESSIONAL'">
                  <!-- recipient.company -->
                  <div class="col-6">
                  <span class="p-float-label">
                    <input id="recipientcompany" [ngClass]="{'invalid': lreObject.recipient.company === ''}"
                           [(ngModel)]="lreObject.recipient.company" type="text" size="30" pInputText>
                    <label for="recipientcompany">{{'UPLOAD_COMPONENT.LRE_S_COMPANY_LABEL' | translate}}</label>
                  </span>
                  </div>
                </div>
                <div class="col-12">
                  <!-- recipient.mailAddress -->
                  <div class="col-6">
                    <span class="p-float-label">
                      <input id="recipientmailAddress"
                             [ngClass]="{'invalid': !isValidMail(lreObject.recipient.mailAddress)}"
                             [(ngModel)]="lreObject.recipient.mailAddress" type="text" size="30" pInputText>
                      <label for="recipientmailAddress">{{'UPLOAD_COMPONENT.LRE_S_MAIL_LABEL' | translate}}</label>
                    </span>
                  </div>
                </div>
                <div class="col-12">
                  <!-- recipient.authenticationType -->
                  <div class="col-3">
                    <p-dropdown [filter]="false" [options]="authTypeItems"
                                [(ngModel)]="lreObject.recipient.authenticationType"></p-dropdown>
                  </div>
                  <!-- recipient.phoneNumber -->
                  <div class="col-6" *ngIf="lreObject.recipient.authenticationType === 'smsOTP'">
                  <span class="p-float-label">
                    <input id="recipientphoneNumber" [ngClass]="{'invalid': lreObject.recipient.phoneNumber === ''}"
                           [(ngModel)]="lreObject.recipient.phoneNumber" type="text" size="30" pInputText>
                    <label for="recipientphoneNumber">{{'UPLOAD_COMPONENT.LRE_S_PHONE_LABEL' | translate}}</label>
                  </span>
                  </div>
                  <div class="col-6" *ngIf="lreObject.recipient.authenticationType !== 'smsOTP'">&nbsp;</div>
                </div>

                <!-- recipient.finalAddress -->
                <div class="col-12">
                  <div class="col-2">
                    <h5>{{'UPLOAD_COMPONENT.LRE_S_ADDRESS_LABEL' | translate}}</h5>
                  </div>
                  <div class="col-8">
                    <textarea rows="5" cols="30" [readOnly]="true"
                              [ngClass]="{'invalid': !isValidAddress(lreObject.recipient.address) }"
                              [(ngModel)]="lreObject.recipient.address" pInputTextarea
                              [autoResize]="false"></textarea>
                  </div>
                  <div class="grid">
                    <button pButton type="button" [icon]="'fa fa-pencil'" class="p-button-info"
                            [label]="'COMMON.EDIT' | translate"
                            (click)="showRecipientAddress()"></button>
                    <p-dialog *ngIf="openRecipientAddress" [(visible)]="openRecipientAddress"
                              [styleClass]="'adressModal'"
                              [appendTo]="'body'"
                              [header]="'FOLD.ACTION_COMPONENT.ADD_MODAL_TITLE' | translate"
                              [draggable]="false"
                              [closable]="true"
                              [resizable]="false"
                              [modal]="true" [closeOnEscape]="false">
                      <app-address (finalAddress)="handleRecipientAddress($event)"
                                   (visible)="handleRecipientAddressClose($event)"
                                   [oldAddress]="currentRecipientAddress"></app-address>
                    </p-dialog>
                  </div>
                </div>
              </div>
            </ng-template>
          </p-tabPanel>
          <p-tabPanel [header]="('UPLOAD_COMPONENT.LRE_SENDER_LABEL' | translate)">
            <ng-template pTemplate="content">
              <div class="grid">
                <!--                <div class="col-12">
                                  &lt;!&ndash; sender.title &ndash;&gt;
                                  <div class="col-4">
                                    <p-dropdown [filter]="false" [options]="titleItems"
                                                [(ngModel)]="lreObject.sender.title"></p-dropdown>
                                  </div>
                                  &lt;!&ndash; sender.firstName &ndash;&gt;
                                  <div class="col-4">
                                  <span class="p-float-label">
                                    <input id="senderFirstName" [ngClass]="{'invalid': lreObject.sender.firstName === ''}"
                                           [(ngModel)]="lreObject.sender.firstName" type="text" size="30" pInputText>
                                    <label for="senderFirstName">{{'UPLOAD_COMPONENT.LRE_S_FIRSTNAME_LABEL' | translate}}</label>
                                  </span>
                                  </div>
                                  &lt;!&ndash; sender.lastName &ndash;&gt;
                                  <div class="col-4">
                                  <span class="p-float-label">
                                    <input id="senderLastName" [ngClass]="{'invalid': lreObject.sender.lastName === ''}"
                                           [(ngModel)]="lreObject.sender.lastName" type="text" size="30" pInputText>
                                    <label for="senderLastName">{{'UPLOAD_COMPONENT.LRE_S_LASTNAME_LABEL' | translate}}</label>
                                  </span>
                                  </div>
                                </div>-->
                <div class="col-12">
                  <!-- sender.company -->
                  <div class="col-6">
                  <span class="p-float-label">
                    <input id="sendercompany" [ngClass]="{'invalid': lreObject.sender.company === ''}"
                           [(ngModel)]="lreObject.sender.company" type="text" size="30" pInputText>
                    <label for="sendercompany">{{'UPLOAD_COMPONENT.LRE_S_COMPANY_LABEL' | translate}}</label>
                  </span>
                  </div>
                  <!-- sender.mailAddress -->
                  <div class="col-6">
                  <span class="p-float-label">
                    <input id="sendermailAddress" [ngClass]="{'invalid': !isValidMail(lreObject.sender.mailAddress)}"
                           [(ngModel)]="lreObject.sender.mailAddress" type="text" size="30" pInputText>
                    <label for="sendermailAddress">{{'UPLOAD_COMPONENT.LRE_S_MAIL_LABEL' | translate}}</label>
                  </span>
                  </div>
                </div>
                <div class="col-12">
                  <!-- sender.authenticationType -->
                  <div class="col-6">
                    <p-dropdown [filter]="false" [options]="authTypeItems"
                                [(ngModel)]="lreObject.sender.authenticationType"></p-dropdown>
                  </div>
                  <!-- sender.phoneNumber -->
                  <div class="col-6" *ngIf="lreObject.sender.authenticationType === 'smsOTP'">
                  <span class="p-float-label">
                    <input id="senderphoneNumber" [ngClass]="{'invalid': lreObject.sender.phoneNumber === ''}"
                           [(ngModel)]="lreObject.sender.phoneNumber" type="text" size="30" pInputText>
                    <label for="senderphoneNumber">{{'UPLOAD_COMPONENT.LRE_S_PHONE_LABEL' | translate}}</label>
                  </span>
                  </div>
                  <div class="col-6" *ngIf="lreObject.sender.authenticationType !== 'smsOTP'">&nbsp;</div>
                </div>

                <!-- sender.finalAddress -->
                <div class="col-12">
                  <div class="col-2">
                    <h5>{{'UPLOAD_COMPONENT.LRE_S_ADDRESS_LABEL' | translate}}</h5>
                  </div>
                  <div class="col-8">
                    <textarea rows="5" cols="30" [readOnly]="true"
                              [ngClass]="{'invalid': !isValidAddress(lreObject.sender.address) }"
                              [(ngModel)]="lreObject.sender.address" pInputTextarea [autoResize]="false"></textarea>
                  </div>
                  <div class="grid">
                    <button pButton type="button" [icon]="'fa fa-pencil'" class="p-button-info"
                            [label]="'COMMON.EDIT' | translate"
                            (click)="showSenderAddress()"></button>
                    <p-dialog *ngIf="openSenderAddress" [(visible)]="openSenderAddress" [styleClass]="'adressModal'"
                              [appendTo]="'body'"
                              [header]="'FOLD.ACTION_COMPONENT.ADD_MODAL_TITLE' | translate"
                              [draggable]="false"
                              [closable]="true"
                              [resizable]="false"
                              [modal]="true" [closeOnEscape]="false">
                      <app-address (finalAddress)="handleSenderAddress($event)"
                                   (visible)="handleSenderAddressClose($event)"
                                   [oldAddress]="currentSenderAddress"></app-address>
                    </p-dialog>
                  </div>
                </div>
              </div>
            </ng-template>
          </p-tabPanel>
        </p-tabView>
      </div>
    </div>
    <!--List of uploadFiles components-->
    <div
      *ngIf="selectedOption === KindOfUpload.LETTER || selectedOption === KindOfUpload.MAILING || selectedOption === KindOfUpload.SPOOL"
      class="grid">
      <div
        [ngClass]="{
          'col-6': selectedOption===KindOfUpload.LETTER || selectedOption===KindOfUpload.SPOOL,
          'col-4': selectedOption===KindOfUpload.MAILING
          }">

        <app-files-upload
          filesTitle="{{selectedOption===KindOfUpload.LETTER ? ('UPLOAD_COMPONENT.KIND_OF_FILE.PRINCIPAL_PLURAL' | translate) : ('UPLOAD_COMPONENT.KIND_OF_FILE.PRINCIPAL_SINGULAR' | translate)}}"
          [moreThanOneFile]="selectedOption===KindOfUpload.LETTER"
          [acceptedFiles]="gestListOfAcceptedFiles(FileStatus.PRINCIPAL)"
          [optional]="false"
          [shouldClearFiles]="shouldClearFiles"
          (isValid)="updateUploadValidity(FileStatus.PRINCIPAL,$event)"
          (selectedFiles)="updateFilesWithStatus(FileStatus.PRINCIPAL,$event)">
        </app-files-upload>

      </div>

      <div [ngClass]="{
          'col-6': selectedOption===KindOfUpload.LETTER || selectedOption===KindOfUpload.SPOOL,
          'col-4': selectedOption  ===KindOfUpload.MAILING
          }">
        <app-files-upload filesTitle="{{ 'UPLOAD_COMPONENT.KIND_OF_FILE.ANNEXE' | translate }}"
                          [moreThanOneFile]="true"
                          [acceptedFiles]="gestListOfAcceptedFiles(FileStatus.ANNEXE)"
                          [optional]="true"
                          [shouldClearFiles]="shouldClearFiles"
                          (isValid)="updateUploadValidity(FileStatus.ANNEXE,$event)"
                          (selectedFiles)="updateFilesWithStatus(FileStatus.ANNEXE,$event)">
        </app-files-upload>
      </div>

      <div class="col-4" *ngIf="selectedOption===KindOfUpload.MAILING">

        <app-files-upload *ngIf="selectedOption===KindOfUpload.MAILING"
                          filesTitle="{{ 'UPLOAD_COMPONENT.KIND_OF_FILE.DATA' | translate }}"
                          [moreThanOneFile]="false"
                          [optional]="false"
                          [shouldClearFiles]="shouldClearFiles"
                          [acceptedFiles]="gestListOfAcceptedFiles(FileStatus.DATA)"
                          (isValid)="updateUploadValidity(FileStatus.DATA,$event)"
                          (selectedFiles)="updateFilesWithStatus(FileStatus.DATA,$event)">
        </app-files-upload>
        <!--
        <app-files-upload *ngIf="selectedOption===KindOfUpload.SPOOL"
                          filesTitle="{{ 'UPLOAD_COMPONENT.KIND_OF_FILE.SPOOL' | translate }}"
                          [moreThanOneFile]="false"
                          [optional]="false"
                          [shouldClearFiles]="shouldClearFiles"
                          [acceptedFiles]="gestListOfAcceptedFiles(FileStatus.SPOOL)"
                          (isValid)="updateUploadValidity(FileStatus.SPOOL,$event)"
                          (selectedFiles)="updateFilesWithStatus(FileStatus.SPOOL,$event)">
        </app-files-upload>
        -->
      </div>
    </div>
    <!--List of problems-->
    <div *ngIf="selectedOption!==KindOfUpload.NONE && selectedOption!==KindOfUpload.LRE && !uploadIsPossible()"
         class="grid">
      <div class="col-12">
        <p-fieldset [legend]="'UPLOAD_COMPONENT.DETECTED_PROBLEMS_LABEL' | translate">
          <ul>
            <li *ngIf="!principalFileValidity">{{ 'UPLOAD_COMPONENT.EXPLICATION_PRINCIPAL' | translate }}</li>
            <li
              *ngIf="selectedOption !== KindOfUpload.LRE && !annexeFileValidity">{{ 'UPLOAD_COMPONENT.EXPLICATION_ANNEX' | translate }}</li>
            <li
              *ngIf="selectedOption===KindOfUpload.MAILING && !dataFileValidity">{{ 'UPLOAD_COMPONENT.EXPLICATION_DATA'
              | translate }}
            </li>
            <li *ngIf="selectedOption===KindOfUpload.SPOOL  && selectedSpool.spoolId === '_NA_'">{{
              'UPLOAD_COMPONENT.EXPLICATION_SPOOL' | translate }}
            </li>
          </ul>
        </p-fieldset>
      </div>
    </div>
  </div>
</div>
